export default __webpack_public_path__ + "static/media/kick.78b57139.png";